import {
  Datagrid,
  List,
  TextField,
  TopToolbar,
  ExportButton,
  FilterButton,
  TextInput,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const filters = [
  <TextInput key="name" source="name" label="Name" alwaysOn />,
  <TextInput key="assetType" source="assetType" label="Asset Type" />,
  <TextInput
    key="assetSubtype"
    source="assetSubtype"
    label="Framework"
  />,
];

const RulesetListActions = (props: any) => (
  <TopToolbar {...props}>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const EmptyRulesetList = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    sx={{ width: '100%', minHeight: '60vh' }}
  >
    <Typography variant="h4" gutterBottom>
      No Document Rulesets yet.
    </Typography>
  </Box>
);

export const RulesetList = (props: any) => (
  <List
    {...props}
    filters={filters}
    queryOptions={{ meta: { raw: true } }}
    actions={<RulesetListActions />}
    empty={<EmptyRulesetList />}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="rulesetType" label="Type" />
      <TextField source="description" />
      <TextField source="assetType" />
      <TextField source="assetSubtype" label="Framework" />
    </Datagrid>
  </List>
);
